// extracted by mini-css-extract-plugin
export default {"overviewContainer":"styles_overviewContainer__WhNHo","title":"styles_title__cZNWd","overviewTable":"styles_overviewTable__OjmBg"};